<template>
  <div>
    <v-row>
      <v-col class="d-flex" cols="6">
        <app-text-field
          class="mr-4"
          label="Data"
          solo
          flat
          background-color="grey lighten-4"
          v-model="params.start_date"
          type="date"
        />
        <app-text-field
          class="mr-4"
          label="Data"
          solo
          flat
          background-color="grey lighten-4"
          v-model="params.end_date"
          type="date"
        />
        <v-btn
          class="mr-4"
          color="primary"
          @click="select()"
          :loading="isAnyLoading"
          :disabled="isAnyLoading"
        >
          Pesquisar
        </v-btn>
      </v-col>

      <v-col>
        <v-switch
          v-model="params.only_with_deliveries"
          label="Filtrar apenas com entregas"
          color="primary"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex" cols="6">
        <CompanySelect
          class="mr-4"
          :item-value="(item) => item.id"
          v-model="params.company_id"
          clearable
          solo
          flat
          background-color="grey lighten-4"
          :dense="false"
          @change="select()"
        />

        <SalesmanSearch
          background-color="grey lighten-4"
          solo
          flat
          :dense="false"
          label="Vendedor"
          hidePosition="true"
          @input="setSalesmanId($event)"
          clearable
        />
      </v-col>
    </v-row>

    <v-row class="mt-10 justify-space-between">
      <v-col>
        <v-card color="primary" elevation="0" dark>
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total em vendas bruto
              <br />
              <b class="text-h4">
                {{ $format.decimal(saleReport.net_total_sum) }}
              </b>
              <br />
              <span style="opacity: 0;">.</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card color="grey lighten-4" elevation="0">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total em vendas c/desconto
              <br />
              <b class="text-h4">
                {{ $format.decimal(saleReport.net_price_cash_total_sum) }}
              </b>
              <br />
              % de desconto
              {{ $format.decimal(calculateDiscountPercentage()) }}%
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card outlined color="grey lighten-4" elevation="0">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Total de devolução de vendas c/desconto
              <br />
              <b class="text-h4">
                {{ $format.decimal(returnReport.net_price_cash_total_sum) }}
              </b>
              <br />
              desconto bruto {{ $format.decimal(returnReport.net_total_sum) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div>
          <apexchart
            v-if="!isLoadingSaleByMonthChart"
            width="100%"
            height="300px"
            type="bar"
            :options="chartOptions"
            :series="chartSeries"
          >
          </apexchart>
          <div v-else class="text-center py-12">
            <v-progress-circular
              indeterminate
              color="primary"
              size="48"
            ></v-progress-circular>
            <div class="mt-4">Carregando gráfico...</div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card color="grey lighten-4" elevation="0">
          <v-progress-linear
            v-if="isLoadingSalePaymentReport"
            indeterminate
            color="primary"
            height="4"
          ></v-progress-linear>
          <v-card-text>
            <h4 class="mb-4 font-weight-medium">
              Vendas por meio de pagamento
            </h4>
            <template v-for="row in salePaymentReport.data || []">
              <div class="my-4">
                <div class="d-flex justify-space-between align-center mb-1">
                  <div>
                    <strong>
                      {{ row.payment_name }}
                    </strong>
                  </div>
                  <div class="text-right">
                    <h3 class="mt-3 text-primary font-weight-regular">
                      R$ {{ $format.decimal(row.sum_value) }}
                    </h3>
                  </div>
                </div>
              </div>
            </template>
            <div
              v-if="!isLoadingSalePaymentReport"
              class="mt-6 pt-4"
              style="border-top: 1px solid #e0e0e0;"
            >
              <div
                class="d-flex justify-space-between align-center font-weight-bold"
              >
                <h4 class="">
                  Total
                </h4>
                <h4 class="text-primary">
                  R$ {{ $format.decimal(grandTotal) }}
                </h4>
              </div>
            </div>
            <app-pagination
              v-if="!isLoadingSalePaymentReport"
              :data="salePaymentReport"
              @click="getSalePaymentReport($event)"
            />
          </v-card-text>
        </v-card>

        <v-card color="grey lighten-4" elevation="0" class="mt-6">
          <v-progress-linear
            v-if="isLoadingSalesByBrand"
            indeterminate
            color="primary"
            height="4"
          ></v-progress-linear>
          <v-card-text>
            <h4 class="mb-4 font-weight-medium">Vendas por marca</h4>
            <template v-for="row in saleByBrandReport.data || []">
              <div class="my-4">
                <div class="d-flex justify-space-between align-center mb-1">
                  <div>
                    <strong>
                      {{ row.brand_id ? row.brand_name : "Sem marca" }}
                    </strong>
                  </div>
                  <div class="text-right">
                    <h3 class="mt-3 text-primary font-weight-regular">
                      R$ {{ $format.decimal(row.net_price_cash_total_sum) }}
                    </h3>
                    <small>Lucro: </small>
                    <small>R$ {{ $format.decimal(row.profit_sum) }}</small>
                  </div>
                </div>
                <!-- <div>
                  <v-progress-linear height="8px" class="rounded-xl" color="primary"></v-progress-linear>
                </div> -->
              </div>
            </template>
            <div
              v-if="!isLoadingSalesByBrand"
              class="mt-6 pt-4"
              style="border-top: 1px solid #e0e0e0;"
            >
              <div
                class="d-flex justify-space-between align-center font-weight-bold"
              >
                <h4 class="">
                  Total
                </h4>
                <h4 class="text-primary">
                  R$
                  {{
                    $format.decimal(
                      saleByBrandReport.data && saleByBrandReport.data[0]
                        ? saleByBrandReport.data[0].grand_total
                        : 0
                    )
                  }}
                </h4>
              </div>
            </div>

            <app-pagination
              v-if="!isLoadingSalesByBrand"
              :data="saleByBrandReport"
              @click="getSalesByBrand($event)"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card color="grey lighten-4" elevation="0">
          <v-progress-linear
            v-if="isLoadingSaleProductByCategory"
            indeterminate
            color="primary"
            height="4"
          ></v-progress-linear>
          <v-card-text>
            <h4 class="mb-4 font-weight-medium">
              Vendas por categoria de produtos
            </h4>
            <template v-for="row in saleProductByCategoryReport.data || []">
              <div class="my-4">
                <div class="d-flex justify-space-between align-center mb-1">
                  <div>
                    <strong>
                      {{
                        row.category_id ? row.category_name : "Sem categoria"
                      }}
                    </strong>
                    <br />
                    <small class="text-medium-emphasis">
                      <!-- ({{ $format.decimal()}}%) -->
                    </small>
                  </div>
                  <div class="text-right">
                    <h3 class="mt-3 text-primary font-weight-regular">
                      R$ {{ $format.decimal(row.total) }}
                    </h3>
                    <small>Lucro: </small>
                    <small>R$ {{ $format.decimal(row.profit_sum) }}</small>
                  </div>
                </div>

                <!-- <div>
                  <v-progress-linear height="8px" class="rounded-xl" color="primary"></v-progress-linear>
                </div> -->
              </div>
            </template>
            <div
              v-if="!isLoadingSaleProductByCategory"
              class="mt-6 pt-4"
              style="border-top: 1px solid #e0e0e0;"
            >
              <div
                class="d-flex justify-space-between align-center font-weight-bold"
              >
                <h4 class="">
                  Total
                </h4>
                <h4 class="text-primary">
                  R$
                  {{
                    $format.decimal(
                      saleProductByCategoryReport.data &&
                        saleProductByCategoryReport.data[0]
                        ? saleProductByCategoryReport.data[0].grand_total
                        : 0
                    )
                  }}
                </h4>
              </div>
            </div>
            <app-pagination
              v-if="!isLoadingSaleProductByCategory"
              :data="saleProductByCategoryReport"
              @click="getSaleProductByCategoryReport($event)"
            />
          </v-card-text>
        </v-card>

        <v-card color="grey lighten-4" elevation="0" class="mt-6">
          <v-progress-linear
            v-if="isLoadingGroupedCustomerSalesByLocation"
            indeterminate
            color="primary"
            height="4"
          ></v-progress-linear>
          <v-card-text>
            <h4 class="mb-4 font-weight-medium">Vendas por localização</h4>
            <template
              v-for="row in groupedCustomerSalesByLocationRepository.data || []"
            >
              <div class="my-4">
                <div class="d-flex justify-space-between align-center mb-1">
                  <div>
                    <strong>
                      {{
                        row.postal_code ? row.location_name : "Consumidor Final"
                      }}
                    </strong>
                    <br />
                    <small class="text-medium-emphasis">
                      Clientes: {{ row.customer_count }} | Última compra:
                      {{ $format.dateBr(row.last_purchase_date) }}
                    </small>
                  </div>
                  <div class="text-right">
                    <h3 class="mt-3 text-primary font-weight-regular">
                      R$ {{ $format.decimal(row.total_value) }}
                    </h3>
                    <small>
                      Ticket médio: R$
                      {{ $format.decimal(row.avg_ticket) }}
                    </small>
                  </div>
                </div>
              </div>
            </template>
            <div
              v-if="!isLoadingGroupedCustomerSalesByLocation"
              class="mt-6 pt-4"
              style="border-top: 1px solid #e0e0e0;"
            >
              <div
                class="d-flex justify-space-between align-center font-weight-bold"
              >
                <h4 class="">
                  Total
                </h4>
                <h4 class="text-primary">
                  R$
                  {{
                    $format.decimal(
                      groupedCustomerSalesByLocationRepository.data &&
                        groupedCustomerSalesByLocationRepository.data[0]
                        ? groupedCustomerSalesByLocationRepository.data[0]
                            .grand_total
                        : 0
                    )
                  }}
                </h4>
              </div>
            </div>
            <app-pagination
              v-if="!isLoadingGroupedCustomerSalesByLocation"
              :data="groupedCustomerSalesByLocationRepository"
              @click="getGroupedCustomerSalesByLocation($event)"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Nova seção de Vendas por Localização -->
    <v-row class="mt-6">
      <!-- <v-col cols="6">

        <v-card color="grey lighten-4" elevation="0">
          <v-card-text>
            Situação da entrega
            <div class="my-4">
              <div class="d-flex justify-space-between align-center">
                <div>
                  {{ saleReport }}
                  {{ row.payment_name }}
                </div>
                <div class="text-right">
                  <h3 class="text-primary font-weight-regular">
                    R$ {{ $format.decimal(row.sum_value) }}
                  </h3>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>

      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import { format } from "date-fns";
import CompanySelect from "@/components/company/ui/CompanySelect.vue";
import SalesmanSearch from "@/components/employees/ui/SalesmanSearch.vue";

export default {
  components: {
    CompanySelect,
    SalesmanSearch,
  },
  data: () => ({
    params: {
      page: 1,
      company_id: null,
      salesman_id: null,
      only_with_deliveries: false,
      start_date: format(new Date(), "yyyy-MM-01"),
      end_date: format(new Date(), "yyyy-MM-dd"),
    },

    saleProductParams: {
      metrics: ["net_total_sum", "profit_sum"],
      dimensions: ["product.brand.name"],
    },
    grandTotal: 0,

    // Loading states
    isLoadingSalesReport: false,
    isLoadingSalePaymentReport: false,
    isLoadingSalesByBrand: false,
    isLoadingSaleProductByCategory: false,
    isLoadingSaleByMonthChart: false,
    isLoadingSalesProduct: false,
    isLoadingGroupedCustomerSalesByLocation: false,

    saleByBrandReport: { data: [] },
    saleReport: {},
    returnReport: {},
    saleProductResult: [],
    salePaymentReport: { data: [] },
    saleProductByCategoryReport: { data: [] },
    groupedCustomerSalesByLocationRepository: { data: [] },
    saleDeliveryStatusReport: {},
    saleByMonthChart: [],

    chartSeries: [],

    chartOptions: {
      chart: {
        id: "vuechart-example",
        type: "bar",

        height: 400,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },

      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: "end",
          borderRadiusWhenStacked: "last",
          dataLabels: {
            total: {
              enabled: false,
              style: {
                fontSize: "12px",
                fontWeight: 500,
              },
            },
          },
          columnWidth: "70%",
        },
      },

      dataLabels: {
        enabled: true,
        formatter: function(val) {
          return `R$ ${val.toFixed(2)}`;
        },
        offsetY: -20,
        position: "center",
        style: {
          align: "center",
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [],
        labels: {
          position: "top",
          style: {
            align: "center",
            colors: "#9aa0ac",
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: function(val) {
            return `R$ ${val.toFixed(2)}`;
          },
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return `R$ ${val.toFixed(2)}`;
          },
        },
      },
      colors: ["#1E90FF", "#32CD32"],
    },
  }),

  created() {
    this.select();
  },

  computed: {
    isAnyLoading() {
      return (
        this.isLoadingSalesReport ||
        this.isLoadingSalePaymentReport ||
        this.isLoadingSalesByBrand ||
        this.isLoadingSaleProductByCategory ||
        this.isLoadingSaleByMonthChart ||
        this.isLoadingSalesProduct ||
        this.isLoadingGroupedCustomerSalesByLocation
      );
    },
  },

  methods: {
    select() {
      // Executa todas as requisições em paralelo
      Promise.all([
        this.getSalesReport(),
        this.getSalePaymentReport(),
        this.getSalesByBrand(),
        this.getSaleProductByCategoryReport(),
        this.getSaleByMonthChart(),
        this.getGroupedCustomerSalesByLocation(),
      ]).catch((error) => {
        console.error("Erro ao carregar dados do dashboard:", error);
      });
    },

    calculateDiscountPercentage() {
      if (this.saleReport) {
        const grossTotal = parseFloat(this.saleReport.net_total_sum || 0);
        const netTotal = parseFloat(
          this.saleReport.net_price_cash_total_sum || 0
        );
        const discount = grossTotal - netTotal;
        const percentage = grossTotal > 0 ? (discount / grossTotal) * 100 : 0;
        return percentage;
      }
      return 0;
    },

    getSalesProduct() {
      this.isLoadingSalesProduct = true;
      this.$http
        .index("bi/sale-product", this.saleProductParams)
        .then((response) => {
          this.saleProductResult = response.saleProduct.sort((a, b) => {
            return b.profit_sum - a.profit_sum;
          });
        })
        .catch((error) => {
          console.error("Erro ao buscar produtos de vendas:", error);
          this.saleProductResult = [];
        })
        .finally(() => {
          this.isLoadingSalesProduct = false;
        });
    },

    getSalesReport() {
      this.isLoadingSalesReport = true;
      return this.$http
        .index("sale/sale-report", this.params)
        .then((response) => {
          this.returnReport = response.returnReport || {};
          this.saleReport = response.saleReport || {};
        })
        .catch((error) => {
          console.error("Erro ao buscar relatório de vendas:", error);
          this.returnReport = {};
          this.saleReport = {};
        })
        .finally(() => {
          this.isLoadingSalesReport = false;
        });
    },

    getSalePaymentReport(page = 1) {
      this.isLoadingSalePaymentReport = true;
      return this.$http
        .index("sale/sale-payment-report", { ...this.params, page: page })
        .then((response) => {
          this.salePaymentReport = response.salePaymentReport || { data: [] };
          this.grandTotal = response.grandTotal || 0;
        })
        .catch((error) => {
          console.error("Erro ao buscar relatório de pagamentos:", error);
          this.salePaymentReport = { data: [] };
          this.grandTotal = 0;
        })
        .finally(() => {
          this.isLoadingSalePaymentReport = false;
        });
    },

    getSalesByBrand(page = 1) {
      this.isLoadingSalesByBrand = true;
      return this.$http
        .index("sale/sale-by-brand-report", {
          ...this.params,
          due_date_start: this.params.start_date,
          due_date_end: this.params.end_date,
          company_id: this.params.company_id,
          page: page,
        })
        .then((response) => {
          this.saleByBrandReport = response.sales || { data: [] };
        })
        .catch((error) => {
          console.error("Erro ao buscar vendas por marca:", error);
          this.saleByBrandReport = { data: [] };
        })
        .finally(() => {
          this.isLoadingSalesByBrand = false;
        });
    },

    getSaleProductByCategoryReport(page = 1) {
      this.isLoadingSaleProductByCategory = true;
      return this.$http
        .index("sale/sale-by-category-report", {
          ...this.params,
          due_date_start: this.params.start_date,
          due_date_end: this.params.end_date,
          company_id: this.params.company_id,
          page: page,
        })
        .then((response) => {
          this.saleProductByCategoryReport = response || { data: [] };
        })
        .catch((error) => {
          console.error("Erro ao buscar vendas por categoria:", error);
          this.saleProductByCategoryReport = { data: [] };
        })
        .finally(() => {
          this.isLoadingSaleProductByCategory = false;
        });
    },

    getSaleDeliveryReport() {
      this.$http
        .index("sale/sale-delivery-status-report", this.params)
        .then((response) => {
          this.saleDeliveryStatusReport = response.saleDeliveryStatusReport;
        });
    },
    getGroupedCustomerSalesByLocation(page = 1) {
      this.isLoadingGroupedCustomerSalesByLocation = true;
      return this.$http
        .index("sale/sale-by-location-report", {
          ...this.params,
          due_date_start: this.params.start_date,
          due_date_end: this.params.end_date,
          page: page,
        })
        .then((response) => {
          this.groupedCustomerSalesByLocationRepository = response || {
            data: [],
          };
        })
        .catch((error) => {
          console.error("Erro ao buscar vendas por localização:", error);
          this.groupedCustomerSalesByLocationRepository = { data: [] };
        })
        .finally(() => {
          this.isLoadingGroupedCustomerSalesByLocation = false;
        });
    },

    getSaleByMonthChart() {
      this.isLoadingSaleByMonthChart = true;
      return this.$http
        .index("sale/sale-by-month-chart", this.params)
        .then((response) => {
          this.saleByMonthChart = response.saleByMonthChart || [];
          this.buildMonthlyChart();
        })
        .catch((error) => {
          console.error("Erro ao buscar dados do gráfico mensal:", error);
          this.saleByMonthChart = [];
          this.buildMonthlyChart();
        })
        .finally(() => {
          this.isLoadingSaleByMonthChart = false;
        });
    },

    setSalesmanId(value) {
      this.params.salesman_id = value ? value.id : null;
      this.select();
    },

    buildMonthlyChart() {
      if (
        !this.saleByMonthChart ||
        !Array.isArray(this.saleByMonthChart) ||
        this.saleByMonthChart.length === 0
      ) {
        this.chartOptions.xaxis.categories = [];
        this.chartSeries = [
          {
            name: "Total Bruto",
            data: [],
          },
          {
            name: "Total Líquido",
            data: [],
          },
        ];
        return;
      }

      this.chartOptions.xaxis.categories = this.saleByMonthChart.map(
        (item) => item.month
      );
      this.chartSeries = [
        {
          name: "Total Bruto",
          data: this.saleByMonthChart.map((item) =>
            parseFloat(item.sum_total || 0)
          ),
        },
        {
          name: "Total Líquido",
          data: this.saleByMonthChart.map((item) =>
            parseFloat(item.total || 0)
          ),
        },
      ];
    },
  },
};
</script>

<style></style>
